import { Route } from "@angular/router";
import { EditDotationComponent } from "./edit-dotation.component";
import { ArticleResolver } from "../../../shared/articles/article-resolver";
import { CabResolver } from "../../../shared/articles/cab-resolver";

export const EditDotationRouting: Route = {
  path: ":code_article/:taille/:code_service/edit",
  component: EditDotationComponent,
  outlet: "sidebar",
  resolve: {
    article: ArticleResolver,
    cab: CabResolver
  },
  data: {
    breadcrumb: "Edit"
  }
};
